module.exports = __webpack_public_path__ + "img/niv_logo.ee09e0f1.png";